import React, { Component } from 'react';
import { withRouter } from 'react-router'
// import { connect }    from 'react-redux';
// import { bindActionCreators } from 'redux';


import { Route, Switch }  from 'react-router-dom'

import Login              from '../../pages/Home/Login';
import SendPasswordReset  from '../../pages/Home/SendPasswordReset';
import ActivateUser       from '../../pages/Home/ActivateUser'
import ResetPassword      from '../../pages/Home/ResetPassword';

class Home extends Component {

  render() {
    return (
      <div>
				<Switch>
          <Route exact path='/' component={Login} />
          <Route exact path='/send-password-reset' component={SendPasswordReset} />
          <Route exact path='/activate_user' component={ActivateUser}/>
          <Route exact path='/reset-password' component={ResetPassword} />
        </Switch>
      </div>
    );
  }
}


export default (withRouter(Home));



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js